import React, { useRef } from "react";
import { BASE_URL } from "../common/constants";
import { Ecard } from "../Ecard";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { HashLink } from "react-router-hash-link";

const ShareEcard = ({ donation, isEditLoad, goToStep, addTransitions }: { donation: any; goToStep: (step: number) => void; addTransitions: any }) => {
  const handleShare = () => {
    const shareUrl = "https://buyabrick.firstunited.ca/" + donation.transaction_id;
    const shareText = `I just bought a brick to support FIRST UNITED’s new installation of public art. See my brick and consider buying your own.`;

    if (navigator.share) {
      navigator
        .share({
          title: "FIRST UNITED Brick Campaign",
          text: shareText,
          url: shareUrl,
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    } else {
      // decide later what to do if share is not supported
      console.log("Share not supported");
    }
  };

  const sharePage = useRef(null);

  useGSAP(() => {
    const introAnimation = gsap.to(sharePage.current, { opacity: 1, duration: 0.5 });
    addTransitions(introAnimation, "ecard-share-intro", false); // intro animation

    const exitAnimation = gsap.to(sharePage.current, { opacity: 0, duration: 0.5 });
    addTransitions(exitAnimation, "ecard-share-exit", true); // exit animation
  }, [addTransitions]);

  return (
    <div className="share-ecard" ref={sharePage}>
      {!isEditLoad && <>
        <p className="text-size-xlarge">Thank you!</p>
        <h1 className="heading">Your purchase is complete</h1>
      </>}
      {isEditLoad && <>
        <h1 className="heading">Your donation has been updated</h1>
      </>}

      {donation && <Ecard donor={donation} goToStep={goToStep} />}

      <section>
        {!isEditLoad && <>
          <h2 className="text-size-large bold">
            Your generosity helps bring this beautiful work of Salish art to life and makes public art more accessible in the Downtown Eastside.
          </h2>
        </>}

        <div className="share-ecard-buttons">
          <div>
            <a href={BASE_URL + "/generate_svg?download=true&id=" + donation.transaction_id} target="_blank" className="button button--s">
              Download Your Certificate
            </a>
            <p>To keep, print, or email to a friend.</p>
          </div>

          <div>
            <button onClick={handleShare} className="button button--s">
              Share Your Certificate
            </button>
            <p>Post on social media or send to a friend.</p>
          </div>
        </div>

        <button onClick={() => goToStep(1)} className="button">
          Buy Another Brick
        </button>

        <p className="share-ecard-alot">
          Need help buying A LOT of bricks? Call us{" "}
          <a className="inline" href="tel:604.335.3047">
            604.336.3047
          </a>
          .
        </p>

        {/* <p>Help us spread the campaign and show off your brick using this custom link:</p> */}

        <div className="share-ecard-buttons">
          <div>
            <HashLink to="/#donors" className="button button--s">
              View Donor List
            </HashLink>
          </div>
        </div>
      </section>
    </div>
  );
};

export { ShareEcard };
